// @ts-nocheck
import RecommenderCard from '@jo-v3/features/JoRecommender/ProgramSelect/RecommenderCard';
import { type FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectDcsCategories, selectDcsDegrees, selectDcsSubjects } from '@core/reducers/dcsSlice';
import { selectAllInputs } from '@core/reducers/inputsSlice';
import type { VoyagerResult } from '@core/ts/results';

import CareerOutlook from '../../components/CareerOutlook';
import CareerPaths from '../../components/CareerPaths';
import { getCategoryByName } from '../../utils/getCategoryByName';
import styles from './JoEmbeddedRecommender.module.css';

type Props = {
  results: VoyagerResult[];
  eventingOverrides: { [key: string]: any };
};

const JoEmbeddedRecommender: FC<Props> = ({ results, eventingOverrides }) => {
  const degree = useSelector(selectDcsDegrees)[0];
  const subject = useSelector(selectDcsSubjects)[0];
  const category = useSelector(selectDcsCategories)[0];

  const industryData = getCategoryByName(category);
  // inputs state properties
  const inputs = useSelector(selectAllInputs);

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <section className={styles.joEmbeddedRecommender}>
      <div className={styles.content}>
        <header>
          <h2 className={styles.title}>
            {`Advance Your Career in ${subject}${inputs?.firstName?.value ? `, ${inputs?.firstName?.value}` : ''}!`}
          </h2>
          <p className={styles.subtitle}>
            These schools can help you grow your business acumen and excel in your career. Explore your matches and
            choose your path.
          </p>
        </header>

        <div id="recommender_results" className={styles.cardsAndStepTracker}>
          <div className={styles.cards}>
            {results?.map((result: any, index: number) => (
              <RecommenderCard
                withImage={false}
                onRecommender={false}
                index={index}
                key={`${result.program.id}-${index}`}
                position={index + 1}
                layout="row"
                result={result}
                eventingOverrides={{
                  location: eventingOverrides?.location,
                  customDimensions: [
                    { key: 'isUserRequested', value: 'true' },
                    ...(eventingOverrides.customDimensions || []),
                  ],
                }}
              />
            ))}
          </div>
          <div className={styles.infoContainer}>
            <CareerPaths industryData={industryData} hideTitle={false} />
            <div className={styles.spacer} />
            <CareerOutlook industryData={industryData} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoEmbeddedRecommender;
